import { queryString } from '../utils/window'
import { injectElement, logger } from '../application/injectDynamicContent'
import { AD_FORMATS, CLASS_NAMES as AD_CLASS_NAMES } from '../organizedByType/config/adsConfig'
import {
  getIsPostPage,
  getIsEmbededPost,
  getIsTopX,
  getIsSlideshow,
} from '../application/pageDataObject'

const { adsDebugDynamicSlot } = queryString
const isNonEmbeddedPostPageOnMobile =
  (getIsPostPage() && !getIsEmbededPost()) || getIsTopX() || getIsSlideshow()
const { BLOCK, EMPTY, INJECTED, DFP } = AD_CLASS_NAMES
const INJECTED_ELEMENT_CONF_DFP_SLOT = {
  className: [BLOCK, INJECTED, EMPTY, DFP].join(' '),
  dataset: {
    slotId: AD_FORMATS.InArticleDynamic,
  },
}

function isDfpDynamicSlotEnabled() {
  return isNonEmbeddedPostPageOnMobile
}

export function initDfpDynamicSlot(config) {
  const dfpLogger = logger.part(adsDebugDynamicSlot, 'dfpDynamicSlot:')
  if (!isDfpDynamicSlotEnabled()) {
    dfpLogger('disabled', { isDfpDynamicSlotEnabled, isNonEmbeddedPostPageOnMobile })
    return false
  }
  return injectElement(INJECTED_ELEMENT_CONF_DFP_SLOT, dfpLogger)
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/config/adInjectedDfpDynamicSlotConfig.js